import create, {initializeAndRegisterHooks} from 'context/create' 
import triggers, * as resolves from './triggers'
import { clearedEditUser, clearedProfilePasswords, clearedUserProfile, emptyUser, ParentState, clearedChangePaymentMethod } from 'types/context/parent'
import { createLoadableList } from 'external/immutability-helper'

const id = 'Parent'

export const initialState: ParentState = {
    homeData: {},
    userPackageDetailsProfile: false,
    userPackageDetails: createLoadableList(),
    userProfile: clearedUserProfile,
    users: createLoadableList(),
    payments: createLoadableList(),
    paymentHistory: createLoadableList(),
    paymentHistorySubscription: {},
    paymentDetailIndex: false,
    changePaymentMethodIndex: false,
    supportForm: {
        name: '',
        email: '',
        id: '',
        message: ''
    } ,
    modals: {
        editUser: clearedEditUser,
        addUser: emptyUser,
        updatePassword: clearedProfilePasswords,
        changePaymentMethod: clearedChangePaymentMethod
    },
    saving: {}
}

const context = create(id, initialState, {onInit: initializeAndRegisterHooks(id, triggers, resolves)})
export {context as default}